import React from 'react';
import {TransitionGroup} from 'react-transition-group';

import AnimatedLetters from '../components/animated-letters.js';
import Gallery from '../components/gallery.js';
import GalleryConfig from '../assets/img/gallery/index.js';
import FadeTransition from '../components/fade-transition.js';
import ImagePreloader from '../components/image-preloader.js';

import '../styles/home.scss';

export default class HomeView extends React.PureComponent {
    state = {
        selectedLetter: false
    };

    selectLetter = (letter, completed) => this.setState({selectedLetter: completed ? letter : false});
    closeGallery = () => this.setState({selectedLetter: false});

    renderLetters() {
        if (!this.state.selectedLetter) {
            return (
                <FadeTransition key="letters">
                    <AnimatedLetters width={700} height={525} onSelectLetter={this.selectLetter} />
                </FadeTransition>
            );
        }
    }

    renderGallery() {
        if (this.state.selectedLetter) {
            let images = GalleryConfig[this.state.selectedLetter];
            return (
                <FadeTransition key="gallery">
                    <ImagePreloader images={images} displayLoading={false}>
                        <Gallery 
                            images={images}
                            onClose={this.closeGallery} />
                    </ImagePreloader>
                </FadeTransition>
            );
        }
    }

    render() {
        let allImages = Object.keys(GalleryConfig).reduce((allImages, letter) => {
            let images = GalleryConfig[letter];
            return allImages.concat(images[0]);
        }, []);

        return (
            <div className="main-container">
                <div className="letters-container">
                    <ImagePreloader images={allImages}>
                        <TransitionGroup>
                            {this.renderLetters()}
                            {this.renderGallery()}
                        </TransitionGroup>
                    </ImagePreloader>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/home.js